// *****
// Habituellement, les scripts nécessaires sont concaténés via Gulp.
// Ici, à cause de PhotoSwipe qui utilise des modules ESM,
// on passe par un import direct depuis l’entry point (ici).
// Du coup dans gulp, le build JS associé utilise ESBuild (au lieu de la concat classique).

import "./commons.js";


// GALERIE IMAGE
// ---------------

import PhotoSwipe from "photoswipe";
import PhotoSwipeLightbox from "photoswipe/lightbox";

export function gallery() {
  if (!document.querySelector(".gl-gallery a.item")) return;

  const lightbox = new PhotoSwipeLightbox({
    gallery: ".gl-gallery",
    children: 'a.item',
    zoom: true,
    initialZoomLevel: "fit",
    secondaryZoomLevel: 2,
    maxZoomLevel: 4,
    wheelToZoom: true,
    pswpModule: PhotoSwipe,
    bgOpacity: 0.9,
    padding: { top: 40, bottom: 40, left: 40, right: 40 },
  });

  lightbox.init();
}


function galleryThumbnails() {
    const gallery = document.querySelector(".gl-gallery");
    const items = gallery.querySelectorAll('.images a.item');
    const thumbnails = gallery.querySelectorAll('.thumbnails img');
    thumbnails.forEach((thumbnail, index) => {
        thumbnail.addEventListener('click', () => {
            items.forEach((item) => {
                item.classList.remove('active');
            });
            thumbnails.forEach((thumb) => {
                thumb.classList.remove('active');
            });
            if (items[index]) {
                items[index].classList.add('active');
                thumbnail.classList.add('active');
            }
        });
    });
}


// INIT

gallery();
galleryThumbnails();
